import { render, staticRenderFns } from "./AssignmentTab.vue?vue&type=template&id=e208be82&scoped=true"
import script from "./AssignmentTab.vue?vue&type=script&lang=js"
export * from "./AssignmentTab.vue?vue&type=script&lang=js"
import style0 from "./AssignmentTab.vue?vue&type=style&index=0&id=e208be82&prod&scoped=true&lang=css"
import style1 from "./AssignmentTab.vue?vue&type=style&index=1&id=e208be82&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e208be82",
  null
  
)

export default component.exports